export const ICONS = {
  pages: 'e96e', // file
  help: 'e94f', // 'globe',
  newsfeed: 'e973', // rss
  blog: 'e929', // pencil
  resources: 'e93f', // paperclip
  tips: 'e953', // lightbulb
  events: 'e963', // users
  learning: 'e98e', // learning
}
